/**
 * Event types for changes
 */
const Events = {
    OPEN: 'd3r.dialog.open',
    OPENED: 'd3r.dialog.opened',
    CLOSE: 'd3r.dialog.close',
    CLOSED: 'd3r.dialog.closed',
    LOADING: 'd3r.dialog.loading',
    LOADED: 'd3r.dialog.loaded',
    DESTROYED: 'd3r.dialog.destroyed',

    delegate: (
        element,
        eventType,
        selector,
        listener,
        options
    ) => {
        element.addEventListener(
            eventType,
            /**
             * @param {Event} event
             */
            function callback(event) {
                if (event.target instanceof HTMLElement || event.target instanceof SVGElement) {
                    var closest = event.target.closest(selector);
                    if (closest) {
                        event.closest = closest;
                        listener(event);
                    }
                }
            },
            options || null
        );
    }
};

export default Events;
